import client from './client';

export async function updateVideo([data], { id }) {
  await client(`api/playables/${id}/`, {
    body: data,
    method: 'PATCH'
  })
}